import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterLink } from '@angular/router';
import { DeferModule } from 'primeng/defer';
import { SkeletonModule } from 'primeng/skeleton';

import { ENVIRONMENT } from '@environment';
import { HffCommonUiUsheruLogoModule } from '@usheru-hff/hff-common/ui-usheru-logo';
import { providerRouteReuseStrategy } from '@usheru-hff/hff-common/util-routes';
import { FeatureFilmInteractionsComponent } from '@usheru-hff/movie-detail/feature-film-interactions';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import { SharedFeatureSocialLinksModule } from '@usheru-hff/shared/feature-social-links';
import { FeatureFilmInteractionsToken } from '@usheru-hff/shared/tokens';
import { SharedUiPictureModule } from '@usheru-hff/shared/ui-picture';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';
import { provideAuthResource, provideBaseServices, provideCacheInterceptor } from '@usheru-hff/shared/utils-providers';

import { provideTrackingService } from '@usheru-hff/sdk/tracking';
import { environment } from '../environments/environment';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterLink,
    HttpClientModule,

    SharedUtilsImageModule,
    HffCommonUiUsheruLogoModule,
    SharedUtilsModule,
    SharedUiPictureModule,
    DeferModule,
    SkeletonModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    SharedFeatureSocialLinksModule
  ],
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment
    },
    {
      provide: FeatureFilmInteractionsToken,
      useClass: FeatureFilmInteractionsComponent
    },
    provideAuthResource(environment),
    provideBaseServices(environment),
    provideTrackingService(),
    provideCacheInterceptor(),
    providerRouteReuseStrategy()
  ],
  bootstrap: []
})
export class AppModule {}
